import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';

const MenuComponent = props => {
  return (
    <header className="bg-white border-bottom" ><Navbar expand="lg">
      <Container>
        <div className="content">
              {/* <Navbar aria-controls="basic-navbar-nav" /> */}
          <Navbar id="main-menu">
            {props.menus ? (
              <Nav className="justify-content-center">
                {props.menus.map((menu, index) =>

                  <span key={index} className="d-flex">
                    <Nav.Item >
                      <Nav.Link className={(menu.key === 'home' ? 'text-white active-menu ' : '') + (menu.MobileLabel ? ' DesktopMenus ' : '')} // href={menu.url} 
                        onClick={() => {
                          props.menuClicked(menu.value);
                          window.open(menu.url, '_self')
                        }}><span id={menu.icon} className="menu-icon"></span> <span className="menuLabel"> {menu.value} </span> </Nav.Link>
                      
                      {menu.MobileLabel ? 
                      <Nav.Link className={(menu.key === 'home' ? 'text-white active-menu mobileMenus ' : 'mobileMenus')} // href={menu.url} 
                        onClick={() => {
                          props.menuClicked(menu.MobileLabel)
                          window.open(menu.url, '_self')
                        }}><span id={menu.icon} className="menu-icon"></span> <span className="menuLabel"> {menu.MobileLabel} </span> </Nav.Link>
                      : '' }
                      
                    </Nav.Item> <span className={(props.menus.length === (index + 1)) ? "d-none" : "vbar"} ></span>
                  </span>
                )}
              </Nav>) : ''}
          </Navbar>   
        </div>

             
      </Container>
    </Navbar>  </header>)
};

export default MenuComponent;